<button
  class="student-chiclet"
  data-testid="student-chiclet-btn"
  [class]="studentStatus().class"
  (click)="selectStudent()"
>
  @if (student().lookImage) {
    <div class="student-chiclet__avatar">
      <lt-avatar [lookImage]="student().lookImage!" [testId]="'student-chiclet-image-' + student().id" />
    </div>
  }

  <span class="student-chiclet__name should-stay-masked" [title]="student().name">
    {{ student().name }}
  </span>

  <lt-icon class="student-chiclet__icon" [name]="studentStatus().icon" [class]="studentStatus().icon"></lt-icon>
</button>
